import React, { Component } from "react";
import { connect } from "react-redux";
import { quiz1DataWatch, quiz1DataUpdate } from "../../actions/quiz1Actions";

import produce from "immer";
import _ from "lodash";

class ViewData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: []
    };
  }

  componentDidMount() {
    const { data } = this.props || {};

    if (_.isEmpty(data)) {
      this.props.quiz1DataWatch();
    } else {
      this.setState(
        produce(draft => {
          draft.data = data;
        })
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { data: prevData } = prevProps;
    const { data: currData } = this.props;
    if (!_.isEqual(prevData, currData)) {
      this.setState(
        produce(draft => {
          draft.data = currData;
          return draft;
        })
      );
    }
  }

  handleChange = (idx, e) => {
    const { value, name } = e.target;
    switch (name) {
      case "no":
        this.setState(
          produce(draft => {
            draft.data[idx][name] = Number.parseInt(value);
          })
        );
        break;
      case "question":
        this.setState(
          produce(draft => {
            draft.data[idx][name] = value;
          })
        );
        break;
      case "answer":
        const bool = value.toUpperCase() === "O" ? true : false;
        this.setState(
          produce(draft => {
            draft.data[idx][name] = bool;
          })
        );
        break;

      default:
        break;
    }
  };

  handleSubmit = (idx, e) => {
    e.preventDefault();
    console.log("submit", idx, this.state.data[idx]);

    this.props.quiz1DataUpdate(idx, this.state.data[idx]);
  };

  renderRow = data => {
    const { data: prevData } = this.props;

    return data.map((d, idx) => (
      <div key={idx} className="row">
        <div className="col-12">
          <form onSubmit={e => this.handleSubmit(idx, e)} className="row">
            {/* NO */}
            <div className="col-1 d-flex justify-content-between align-items-center my-1">
              <input
                className="d-block w-100"
                type="text"
                name="no"
                value={d.no}
                onChange={e => this.handleChange(idx, e)}
                readOnly
              />
            </div>

            {/* QUESTION */}
            <div className="col-9 d-flex justify-content-between align-items-center my-1">
              <textarea
                rows="1"
                className="d-block w-100"
                type="text"
                name="question"
                value={d.question}
                onChange={e => this.handleChange(idx, e)}
              />
            </div>

            {/* ANSWER */}
            <div className="col-1 d-flex justify-content-between align-items-center my-1">
              <select
                className="d-block w-100"
                type="text"
                name="answer"
                value={d.answer === true ? "O" : "X"}
                onChange={e => this.handleChange(idx, e)}
                style={{ borderColor: d.answer ? "blue" : "red" }}
              >
                <option value="O" style={{ backgroundColor: "white" }}>
                  O
                </option>
                <option value="X" style={{ backgroundColor: "white" }}>
                  X
                </option>
              </select>
            </div>

            {/* SUBMIT */}
            <div className="col-1 d-flex justify-content-between align-items-center my-1">
              <button
                type="submit"
                className="d-block w-100 btn btn-danger btn-block"
                style={{ height: "100%" }}
                disabled={_.isEqual(data[idx], prevData[idx])}
              >
                수정
              </button>
            </div>
          </form>
        </div>
      </div>
    ));
  };

  render() {
    const { data } = this.state;
    return <div>{this.renderRow(data)}</div>;
  }
}

const mapStateToProps = state => ({
  data: state.quiz1.data
});

export default connect(
  mapStateToProps,
  { quiz1DataWatch, quiz1DataUpdate }
)(ViewData);
